var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssessment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "assessment"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.0161 3.14697H5.26715C4.1083 3.14697 3.16016 4.04697 3.16016 5.14697V19.147C3.16016 20.247 4.1083 21.147 5.26715 21.147H20.0161C21.175 21.147 22.1231 20.247 22.1231 19.147V5.14697C22.1231 4.04697 21.175 3.14697 20.0161 3.14697ZM20.0161 19.147H5.26715V5.14697H20.0161V19.147ZM7.37415 10.147H9.48114V17.147H7.37415V10.147ZM11.5881 7.14697H13.6951V17.147H11.5881V7.14697ZM15.8021 13.147H17.9091V17.147H15.8021V13.147Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessment);
export default __webpack_public_path__ + "static/media/Assessment.7e16c70c14050b0ec21d44fdf0eaf92e.svg";
export { ForwardRef as ReactComponent };